import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ProductsPage from './pages/ProductsPage';
import BrandsPage from './pages/BrandsPage';
import SuppliersPage from './pages/SuppliersPage';
import TasksPage from './pages/TasksPage';
import SchedulePage from './pages/SchedulePage';
import UploadPage from './pages/UploadPage';
import LoginPage from './pages/LoginPage';
import UsersPage from './pages/UsersPage';
import ColorsPage from './pages/ColorsPage';
import FactoriesPage from './pages/FactoriesPage';
import BotUsersPage from './pages/BotUsersPage';
import { useAuth } from './context/AuthContext';

// Компонент для защищенных маршрутов
function ProtectedRoute({ children, requireAdmin = false, allowColorsOnly = false }) {
  const { isAuthenticated, isAdmin, isColorsOnly } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Пользователь с colors_only может зайти только на разрешенные страницы
  if (isColorsOnly && !allowColorsOnly) {
    return <Navigate to="/colors" replace />;
  }

  if (requireAdmin && !isAdmin) {
    // Если не админ, перенаправляем в зависимости от роли
    if (isColorsOnly) {
      return <Navigate to="/colors" replace />;
    }
    return <Navigate to="/upload" replace />;
  }

  return children;
}

function App() {
  const { isAuthenticated, isColorsOnly, loading } = useAuth();

  if (loading) {
    return <div className="container">Загрузка...</div>;
  }

  // Определяем стартовую страницу в зависимости от роли
  const getDefaultPage = () => {
    if (isColorsOnly) return '/colors';
    return '/upload';
  };

  return (
    <>
      {isAuthenticated && <Navigation />}
      <div className="container">
        <Routes>
          <Route path="/login" element={isAuthenticated ? <Navigate to={getDefaultPage()} replace /> : <LoginPage />} />
          
          {/* Маршруты только для администратора */}
          <Route
            path="/"
            element={
              <ProtectedRoute requireAdmin={true}>
                <ProductsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/products"
            element={
              <ProtectedRoute requireAdmin={true}>
                <ProductsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/brands"
            element={
              <ProtectedRoute requireAdmin={true}>
                <BrandsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/suppliers"
            element={
              <ProtectedRoute requireAdmin={true}>
                <SuppliersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/factories"
            element={
              <ProtectedRoute requireAdmin={true}>
                <FactoriesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tasks"
            element={
              <ProtectedRoute requireAdmin={true}>
                <TasksPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/schedule"
            element={
              <ProtectedRoute requireAdmin={true}>
                <SchedulePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute requireAdmin={true}>
                <UsersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bot-users"
            element={
              <ProtectedRoute requireAdmin={true}>
                <BotUsersPage />
              </ProtectedRoute>
            }
          />
          
          {/* Маршрут для всех авторизованных пользователей */}
          <Route
            path="/upload"
            element={
              <ProtectedRoute>
                <UploadPage />
              </ProtectedRoute>
            }
          />
          
          {/* Маршрут для работы с цветами (доступен всем, включая colors_only) */}
          <Route
            path="/colors"
            element={
              <ProtectedRoute allowColorsOnly={true}>
                <ColorsPage />
              </ProtectedRoute>
            }
          />
          
          {/* Перенаправление на login для всех остальных маршрутов */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
        <Footer />
      </div>
    </>
  );
}

export default App;
